import { render, staticRenderFns } from "./StatusSolicitacaoIcon.vue?vue&type=template&id=07bdb237&scoped=true&"
import script from "./StatusSolicitacaoIcon.vue?vue&type=script&lang=js&"
export * from "./StatusSolicitacaoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bdb237",
  null
  
)

export default component.exports